import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

/** Fixed step height shared by the document-page wizards (Hannibal parity). */
export const WIZARD_STEP_BODY_HEIGHT = 'h-[480px]';

/**
 * WizardStepBody — fixed-size body frame for multi-step modal wizards
 * (Generate Report / LOA / Upload). Guarantees every step of every wizard is
 * the SAME height (no dialog resize between steps) and lets sparse steps center
 * vertically (align="center") while scrolling lists / large textareas top-align
 * and fill the frame (align="top"). Content taller than the frame scrolls
 * inside it. Distinct from WizardStepContainer (min-h + framer-motion).
 */
export function WizardStepBody({
  align = 'center',
  className,
  children,
}: {
  align?: 'center' | 'top';
  className?: string;
  children: ReactNode;
}) {
  return (
    <div
      className={cn(
        'scrollbar-dark flex flex-col overflow-y-auto py-2',
        WIZARD_STEP_BODY_HEIGHT,
        align === 'center' ? 'justify-center' : 'justify-start',
        className
      )}
    >
      {children}
    </div>
  );
}
